var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 6.5568C2.5795 6.5568 2.39062 6.75522 2.39062 6.99999C2.39062 7.24475 2.5795 7.44317 2.8125 7.44317H7.3125C7.5455 7.44317 7.73438 7.24475 7.73438 6.99999C7.73438 6.75522 7.5455 6.5568 7.3125 6.5568H2.8125Z",
    fill: "#1F1A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39062 8.77272C2.39062 8.52796 2.5795 8.32954 2.8125 8.32954H5.625C5.858 8.32954 6.04688 8.52796 6.04688 8.77272C6.04688 9.01748 5.858 9.2159 5.625 9.2159H2.8125C2.5795 9.2159 2.39062 9.01748 2.39062 8.77272Z",
    fill: "#1F1A5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6875 8.18182C10.6875 7.20277 11.443 6.40909 12.375 6.40909H14.0625C14.9945 6.40909 15.75 7.20277 15.75 8.18182V8.77273C15.75 9.75178 14.9945 10.5455 14.0625 10.5455H12.375C11.443 10.5455 10.6875 9.75178 10.6875 8.77273V8.18182ZM12.375 7.29545H14.0625C14.5285 7.29545 14.9062 7.69229 14.9062 8.18182V8.77273C14.9062 9.26225 14.5285 9.65909 14.0625 9.65909H12.375C11.909 9.65909 11.5312 9.26225 11.5312 8.77273V8.18182C11.5312 7.69229 11.909 7.29545 12.375 7.29545Z",
    fill: "#1F1A5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 0.5C0.75552 0.5 0 1.29368 0 2.27273V11.7273C0 12.7063 0.75552 13.5 1.6875 13.5H16.3125C17.2445 13.5 18 12.7063 18 11.7273V2.27273C18 1.29368 17.2445 0.5 16.3125 0.5H1.6875ZM16.3125 1.38636H1.6875C1.22151 1.38636 0.84375 1.7832 0.84375 2.27273V3.60228H17.1562V2.27273C17.1562 1.7832 16.7785 1.38636 16.3125 1.38636ZM0.84375 11.7273V4.48865H17.1562V11.7273C17.1562 12.2168 16.7785 12.6136 16.3125 12.6136H1.6875C1.22151 12.6136 0.84375 12.2168 0.84375 11.7273Z",
    fill: "#1F1A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.3a21422bb7f7ea4facb2e89fe981175d.svg";
export { ForwardRef as ReactComponent };